var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 9.31373 2.68629 12 6 12C9.31373 12 12 9.31373 12 6C12 2.68629 9.31373 0 6 0C2.68629 0 0 2.68629 0 6ZM3.93094 3.9309C4.14892 3.71294 4.50231 3.71296 4.72026 3.93094L6 5.21079L7.27976 3.93094C7.49771 3.71296 7.85107 3.71294 8.06908 3.9309C8.28703 4.14885 8.28703 4.50224 8.06908 4.72023L6.78927 6.00017L8.06874 7.27976C8.2867 7.49777 8.2867 7.85113 8.06869 8.06908C7.85074 8.28703 7.49732 8.28703 7.27937 8.06908L6 6.78954L4.72063 8.06908C4.50267 8.28703 4.14928 8.28703 3.93129 8.06908C3.71332 7.85113 3.7133 7.49777 3.93126 7.27976L5.21074 6.00017L3.9309 4.72023C3.71294 4.50224 3.71296 4.14885 3.93094 3.9309Z",
    fill: "#FF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/close-red.bea482fdd70b57e9c39773a38f89d983.svg";
export { ForwardRef as ReactComponent };